import * as React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Box, Button } from '@mui/material';
import { useState } from 'react';

import { AppContainer } from 'components/common/appContainer';
import { useSendRequirementForApproval } from 'hooks/useSendRequirementForApproval';
import { Routes } from 'navigation/routes';
import { UILoader } from 'components/UI/UILoader';
import { UITextField } from 'components/UI/UITextField';
import { userRolesPermissions } from 'core/constants/userRolesPermissions';
import { UserRightsContainer } from 'components/common/UserRightsContainer';
import { TaskDeadlineModal } from 'components/common/TaskDeadlineModal/TaskDeadlineModal';

const ApproveRequirement = () => {
    const navigate = useNavigate();
    const { requirementId } = useParams();

    const { requirement, onApprove } = useSendRequirementForApproval(requirementId);
    const [deadlineModalVisible, setDeadlineRejectModalVisible] = useState<boolean>(false);

    const onEditRequirement = (): void => {
        navigate(`${Routes.EditRequirement}/${requirementId as string}`);
    };

    const onCancel = (): void => {
        navigate(-1);
    };

    return (
        <AppContainer>
            <UserRightsContainer allowedUserRoles={userRolesPermissions.requirements.approve}>
                <div className={'container_thin'}>
                    <h2>Принять решение</h2>
                    {requirement ? (
                        <div>
                            <UITextField value={requirement?.text} label={'Текст требования'} multiline disabled />
                            <Box sx={{ display: 'flex', marginBottom: 4, marginTop: 2 }}>
                                <Box mr={'10px'}>
                                    <Button variant="contained" onClick={() => setDeadlineRejectModalVisible(true)}>
                                        Согласовать требование
                                    </Button>
                                </Box>
                                <Box mr={'10px'}>
                                    <Button variant="outlined" onClick={onEditRequirement}>
                                        Редактировать требование
                                    </Button>
                                </Box>
                                <Box mr={'10px'}>
                                    <Button variant="outlined" onClick={onCancel}>
                                        Назад
                                    </Button>
                                </Box>
                            </Box>
                            <TaskDeadlineModal
                                isVisible={deadlineModalVisible}
                                setIsVisible={setDeadlineRejectModalVisible}
                                onSuccess={(date) => onApprove(date)}
                            />
                        </div>
                    ) : (
                        <UILoader isVisible />
                    )}
                </div>
            </UserRightsContainer>
        </AppContainer>
    );
};

export { ApproveRequirement };
